import React, { type JSX } from 'react';
import { remove } from 'ramda';
import {
  RemoveUrvalMutation as IRemoveUrvalData,
  RemoveUrvalMutationVariables as IRemoveUrvalVariables,
} from './_QueryTypes/RemoveUrvalMutation';
import RemoveUrvalDoc from './RemoveUrvalMutation.gql';
import { Mutation } from '@apollo/client/react/components';
import { MutationFunction as MutationFn, DataProxy } from '@apollo/client';
import {
  RutinUrvalListQuery as IRutinUrvalListQueryData,
  RutinUrvalListQueryVariables as IRutinUrvalListQueryVariables,
} from '../Queries/RutinUrvalListQuery/_QueryTypes/RutinUrvalListQuery';
import rutinUrvalListQuery from '../Queries/RutinUrvalListQuery/RutinUrvalListQuery.gql';

type RemoveUrvalFnType = MutationFn<IRemoveUrvalData, IRemoveUrvalVariables>;
export type RemoveUrvalMutationUpdaterType = (
  proxy: DataProxy,
  removedUrvalId: string
) => void;

interface IProps {
  children: (removeUrvalFn: (id: string) => void) => JSX.Element;
  rutinUrvalListVariables?: IRutinUrvalListQueryVariables;
  removeUrvalMutationUpdater?: RemoveUrvalMutationUpdaterType;
}

class RemoveUrval extends React.Component<IProps> {
  removeUrval = (removeUrvalFn: RemoveUrvalFnType) => (id: string) => {
    removeUrvalFn({
      variables: { id },
      update: (store, result) => {
        const cacheData = store.readQuery<
          IRutinUrvalListQueryData,
          IRutinUrvalListQueryVariables
        >({
          query: rutinUrvalListQuery,
          variables: this.props.rutinUrvalListVariables,
        });

        const cachedRutinUrvalList = cacheData && cacheData.routineselections;
        if (cachedRutinUrvalList != null) {
          const removedIndex = cachedRutinUrvalList.findIndex(
            urval => urval.id === id
          );

          if (removedIndex !== -1) {
            const updatedRutinUrvalList = remove(
              removedIndex,
              1,
              cachedRutinUrvalList
            );

            store.writeQuery<
              IRutinUrvalListQueryData,
              IRutinUrvalListQueryVariables
            >({
              data: { routineselections: updatedRutinUrvalList },
              query: rutinUrvalListQuery,
              variables: this.props.rutinUrvalListVariables,
            });
          }

          if (this.props.removeUrvalMutationUpdater) {
            this.props.removeUrvalMutationUpdater(
              store,
              cachedRutinUrvalList[removedIndex].urvalID || ''
            );
          }
        }
      },
    });
  };

  render() {
    return (
      <Mutation<IRemoveUrvalData, IRemoveUrvalVariables>
        mutation={RemoveUrvalDoc}
      >
        {mutationFn => this.props.children(this.removeUrval(mutationFn))}
      </Mutation>
    );
  }
}

export default RemoveUrval;
